<app-dynamic-form title="Member" [input]="data!" (result)="doHandleResult($event)"></app-dynamic-form>
